export const sortList = (list: any[], direction: 'ASC' | 'DESC', key: string): any[] => {
  const sortedList = [...list]

  sortedList.sort((a, b) => {
    const aValue = a[key]
    const bValue = b[key]

    if (direction === 'ASC') {
      return compare(aValue, bValue)
    } else if (direction === 'DESC') {
      return compare(bValue, aValue)
    }

    return 0
  })

  return sortedList
}

const compare = (a: any, b: any): number => {
  if (a < b) {
    return -1
  } else if (a > b) {
    return 1
  } else {
    return 0
  }
}
